import { ListItemIcon, MenuItem, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

const CommonTable = ({
  columnsList = [],
  dataList = [],
  isLoading = false,
  renderCustomToolbar,
  enableRowActions = false,
  positionActionsColumn = "last",
  renderRowActionMenuItems
}: { columnsList: any, dataList: any, isLoading: boolean, renderCustomToolbar: any, enableRowActions?: boolean, positionActionsColumn?: any, renderRowActionMenuItems?: ({ closeMenu }: { closeMenu: () => void }) => JSX.Element[], }) => {
  const table = useMaterialReactTable({
    columns: columnsList,
    data: dataList,
    state: { isLoading: isLoading },
    renderTopToolbarCustomActions: renderCustomToolbar ?? renderCustomToolbar(),
    initialState: {
      pagination: {
        pageIndex: 0, // Set the default page index (starting from page 0)
        pageSize: 30, // Set the default page size
      },
    },
    
    muiTableContainerProps: {},
    muiTableHeadProps: {
      sx: {
        "& th": {
          borderRightWidth: "1px",
          borderTopWidth: "1px",
          fontFamily: "Poppins",
        },
        zIndex: 1,
      },
    },
    muiTableBodyProps: {
      sx: {
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
        {
          backgroundColor: "#f5f5f5",
        },
        "& tr>td": {
          borderBottom: "0px",
          borderRightWidth: "1px",
          fontFamily: "Poppins",
        },
      },
    },
    muiSkeletonProps: {
      animation: "pulse",
      height: 28,
    },
    muiCircularProgressProps: {
      color: "error",
      thickness: 2,
      size: 35,
    },
    enableFilters: false,
    enableColumnFilters: false,
    enableColumnActions: false,
    enableHiding: false,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    enableMultiRowSelection: false,
    enableRowActions,
    positionActionsColumn,
    renderRowActionMenuItems
    
  });

  return <MaterialReactTable table={table} />;
};

export default CommonTable;
